import { numberWithCommas } from '@node-space/utils'
import { WalletStatus } from 'types/wallets'
import { WalletType } from '../../../../types/types'
import { TableSectionItem } from '../../types'

/*
 * Based on total amount and base currency build string
 */
export const formatTotal = (total: number, baseCurrency: string): string =>
  total ? `${numberWithCommas(total)} ${baseCurrency}` : ''

export const isActiveWallet = (wallet: WalletType | TableSectionItem): boolean => {
  if (!wallet?.status) {
    return true
  }

  return (
    wallet?.status !== WalletStatus.INACTIVE &&
    wallet?.status !== WalletStatus.SUSPENDED_BY_ACCOUNT_SUSPENSION
  )
}
